var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.5 20.6",
    style: {
      enableBackground: "new 0 0 18.5 20.6"
    },
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete",
    fill: "current",
    transform: "translate(0.75 0.75)",
    d: "M15.1,19.8H1.9c-0.4,0-0.8-0.3-0.8-0.8V5.7C1.1,5.3,1.5,5,1.9,5 s0.8,0.3,0.8,0.8v12.6h11.8V5.7c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v13.3C15.9,19.5,15.5,19.8,15.1,19.8z M6.5,15.5v-8 c0-0.4-0.3-0.7-0.7-0.7S5.1,7.2,5.1,7.5v8c0,0.4,0.3,0.7,0.7,0.7S6.5,15.9,6.5,15.5z M9.4,15.5v-8c0-0.4-0.3-0.7-0.7-0.7 S8,7.2,8,7.5v8c0,0.4,0.3,0.7,0.7,0.7S9.4,15.9,9.4,15.5z M12.2,15.5v-8c0-0.4-0.3-0.7-0.7-0.7s-0.7,0.3-0.7,0.7v8 c0,0.4,0.3,0.7,0.7,0.7S12.2,15.9,12.2,15.5z M17.8,3.3c0,0.4-0.3,0.8-0.8,0.8H0c-0.4,0-0.8-0.3-0.8-0.8S-0.4,2.6,0,2.6h4.9 c0.2-1.9,1.7-3.3,3.6-3.3c0,0,0,0,0,0c1.9,0,3.4,1.5,3.6,3.3H17C17.4,2.6,17.8,2.9,17.8,3.3z M6.4,2.6h4.2c-0.1-1-1-1.8-2.1-1.8 c0,0,0,0,0,0C7.4,0.8,6.6,1.6,6.4,2.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.142c93c71d5f55a8cafd372373b0e1d2.svg";
export { ForwardRef as ReactComponent };